import { campoDeveSerMaiorQueZero, campoObrigatorio } from 'helpers/Constantes/Mensagens'

export type DadosLoteadora = {
  precoLote: string | number
  valido: boolean
}

export const dadosLoteadoraValorDefault = {
  precoLote: ''
} as DadosLoteadora

export class ValidacaoDadosLoteadora {
  precoLote: string

  constructor(precoLote = '') {
    this.precoLote = precoLote
  }

  validarPrecoLote(precoLote: string): string {
    let error = ''

    if (parseFloat(precoLote) === 0) error = campoDeveSerMaiorQueZero

    if (precoLote === '') error = campoObrigatorio

    return error
  }

  validarTodosCampos(state: DadosLoteadora): boolean {
    return state.precoLote != '' && this.precoLote === ''
  }
}
